import { motion } from "framer-motion";

const HERO_IMG =
  "https://images.unsplash.com/photo-1501686637-b7aa9c48a882?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxjaGlsZCUyMHRoZXJhcGlzdCUyMHBsYXlpbmclMjBibG9ja3N8ZW58MHx8fHwxNzg1NzQ2NTU3fDA&ixlib=rb-4.1.0&q=85";

const lines = ["Where every", "child finds", "their rhythm."];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};
const lineVariant = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const Hero = () => {
  return (
    <section id="top" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-end">
          {/* Text */}
          <div className="lg:col-span-7">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.1, duration: 0.8 }}
              className="flex items-center gap-3 text-sm tracking-[0.2em] uppercase text-brand-muted mb-8"
              data-testid="hero-eyebrow"
            >
              <span className="h-px w-10 bg-brand-secondary" />
              ABA Clinic · Ahmednagar
            </motion.p>

            <motion.h1
              variants={container}
              initial="hidden"
              animate="show"
              className="font-display font-light text-5xl sm:text-6xl md:text-7xl leading-[1.02] tracking-tight text-brand-primary"
              data-testid="hero-heading"
            >
              {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden">
                  <motion.span variants={lineVariant} className="block">
                    {i === 2 ? (
                      <>
                        their <span className="italic text-brand-secondary">rhythm.</span>
                      </>
                    ) : (
                      line
                    )}
                  </motion.span>
                </span>
              ))}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.8 }}
              className="mt-8 max-w-md text-lg text-brand-ink/70 leading-relaxed"
              data-testid="hero-subtext"
            >
              NeuroNest is a warm, evidence-based ABA therapy clinic helping young
              children grow through play, connection and early intervention.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.05, duration: 0.8 }}
              className="mt-10 flex flex-wrap items-center gap-4"
            >
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="rounded-full bg-brand-primary text-brand-bg px-8 py-4 text-sm hover:bg-[#1f332a] transition-colors duration-300"
              >
                Book an assessment
              </a>
              <a
                href="#approach"
                data-testid="hero-cta-secondary"
                className="rounded-full border border-brand-primary text-brand-primary px-8 py-4 text-sm hover:bg-brand-primary hover:text-brand-bg transition-colors duration-300"
              >
                Our approach
              </a>
            </motion.div>
          </div>

          {/* Image with parallax */}
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="absolute -top-6 -left-6 h-24 w-24 rounded-full bg-brand-accent -z-0" />
              <div className="relative overflow-hidden rounded-3xl shadow-[0_20px_60px_rgba(46,74,61,0.18)]">
                <img
                  src={HERO_IMG}
                  alt="Child playing with wooden blocks during therapy"
                  className="h-[360px] sm:h-[460px] w-full object-cover"
                  data-testid="hero-image"
                />
              </div>
              <div className="absolute -bottom-5 -right-3 sm:right-6 bg-brand-bg rounded-2xl px-5 py-4 shadow-[0_8px_32px_rgba(46,74,61,0.12)] border border-brand-primary/10">
                <p className="font-display text-2xl text-brand-primary">100%</p>
                <p className="text-xs text-brand-muted">Individualised care plans</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
